import React from 'react';
import { Link } from 'react-router-dom'; 
import './Navbar.css'; 

function Navbar() {
  const logoUrl = process.env.PUBLIC_URL + '/logo.svg'; 
  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" className="navbar-logo-link">
          <img src={logoUrl} alt="无聊百科 Logo" className="navbar-logo-svg" />
          无聊百科
        </Link>
      </div>
      <ul className="navbar-links">
        <li><Link to="/">首页</Link></li> 
        {/* Example category links - these will need to match routes in App.js */}
        <li><Link to="/categories/cold-knowledge">冷知识</Link></li>
        <li><Link to="/categories/strange-questions">怪问题</Link></li>
        <li><Link to="/categories/ai-generated">AI瞎编</Link></li>
        {/* Add a general 'All Categories' link if needed */}
        <li><Link to="/categories">所有分类</Link></li>
      </ul>
    </nav>
  );
}

export default Navbar;
